import axios from "axios";
import { API } from "../../utils/index";
const instance = axios.create();

export const postContact = async (contact) => {
  return instance.post(`${API}/contact`, contact);
};

export const postNewsLetter = async (newsLetter) => {
  return instance.post(`${API}/contact/newsLetter`, newsLetter);
};
